import { createSelector, createFeatureSelector } from '@ngrx/store';
import {
  AppState,
  TotalNitrogenLegalNormState,
  LegalNitrogenWorkingCoefficientState,
  CropVarietySpecificNormState,
  PhosphateLegalNormState,
  TreatmentType,
  PhosphateLegalWorkingCoefficientState,
} from 'src/app/shared/models';

import { cropVarietySpecificNormAdapter } from './cropVarietySpecificNorm.reducer';
import { legalNitrogenWorkingCoefficientsAdapter } from './legalNitrogenWorkingCoefficient.reducer';
import { phosphateLegalNormAdapter } from './phosphateLegalNorm.reducer';
import { phosphateLegalWorkingCoefficientsAdapter } from './phosphateLegalWorkingCoefficient.reducer';
import { totalNitrogenLegalNormAdapter } from './totalNitrogenLegalNorm.reducer';

export const getAppState = createFeatureSelector<AppState>('app');

export const getCrops = createSelector(getAppState, (state) => state?.crops);

export const getCropVarieties = createSelector(getAppState, (state) => state?.cropVarieties);

export const getCropAids = createSelector(getAppState, (state) => state?.cropAids);

export const getSoilTypes = createSelector(getAppState, (state) => state?.soilTypes);

export const getSalesOrderPeriods = createSelector(getAppState, (state) => state.salesOrderPeriods || []);

export const getFertilizationSalesOrderPeriods = createSelector(getSalesOrderPeriods, (salesOrderPeriods) =>
  salesOrderPeriods.filter((b) => b.periodType === TreatmentType.Fertilization),
);

export const getTotalNitrogenLegalNormState = createFeatureSelector<TotalNitrogenLegalNormState>('totalNitrogenLegalNorm');

const totalNitrogenLegalNormSelectors = totalNitrogenLegalNormAdapter.getSelectors();

export const getTotalNitrogenLegalNorms = createSelector(getTotalNitrogenLegalNormState, totalNitrogenLegalNormSelectors.selectAll);

export const getTotalNitrogenLegalNormPagination = createSelector(getAppState, (state) => state?.totalNitrogenLegalNormPagination);

export const getTotalNitrogenLegalNormTotalNumberOfItems = createSelector(getTotalNitrogenLegalNormPagination, (pagination) => pagination?.itemCount);

export const getTotalNitrogenLegalNormFilter = createSelector(getAppState, (state) => state?.totalNitrogenLegalNormFilter);

export const getLegalNitrogenWorkingCoefficientState = createFeatureSelector<LegalNitrogenWorkingCoefficientState>('legalNitrogenWorkingCoefficient');

const legalNitrogenWorkingCoefficientSelectors = legalNitrogenWorkingCoefficientsAdapter.getSelectors();

export const getLegalNitrogenWorkingCoefficients = createSelector(getLegalNitrogenWorkingCoefficientState, legalNitrogenWorkingCoefficientSelectors.selectAll);

export const getLegalNitrogenWorkingCoefficientsPagination = createSelector(getAppState, (state) => state?.legalNitrogenWorkingCoefficientsPagination);

export const getLegalNitrogenWorkingCoefficientsNumberOfItems = createSelector(
  getLegalNitrogenWorkingCoefficientsPagination,
  (pagination) => pagination?.itemCount,
);

export const getLegalNitrogenWorkingCoefficientsFilter = createSelector(getAppState, (state) => state?.legalNitrogenWorkingCoefficientsFilter);

export const getCropVarietySpecificNormState = createFeatureSelector<CropVarietySpecificNormState>('cropVarietySpecificNorm');

const cropVarietySpecificNormSelectors = cropVarietySpecificNormAdapter.getSelectors();

export const getCropVarietySpecificNorms = createSelector(getCropVarietySpecificNormState, cropVarietySpecificNormSelectors.selectAll);

export const getCropVarietySpecificNormPagination = createSelector(getAppState, (state) => state?.cropVarietySpecificNormPagination);

export const getCropVarietySpecificNormTotalNumberOfItems = createSelector(getCropVarietySpecificNormPagination, (pagination) => pagination?.itemCount);

export const getCropVarietySpecificNormFilter = createSelector(getAppState, (state) => state?.cropVarietySpecificNormFilter);

export const getPhosphateLegalNormState = createFeatureSelector<PhosphateLegalNormState>('phosphateLegalNorm');

const phosphateLegalNormSelectors = phosphateLegalNormAdapter.getSelectors();

export const getPhosphateLegalNorms = createSelector(getPhosphateLegalNormState, phosphateLegalNormSelectors.selectAll);

export const getPhosphateLegalNormPagination = createSelector(getAppState, (state) => state?.phosphateLegalNormPagination);

export const getPhosphateLegalNormTotalNumberOfItems = createSelector(getPhosphateLegalNormPagination, (pagination) => pagination?.itemCount);

export const getPhosphateLegalNormFilter = createSelector(getAppState, (state) => state?.phosphateLegalNormFilter);

export const getPhosphateLegalWorkingCoefficientState = createFeatureSelector<PhosphateLegalWorkingCoefficientState>('phosphateLegalWorkingCoefficient');

const phosphateLegalWorkingCoefficientSelectors = phosphateLegalWorkingCoefficientsAdapter.getSelectors();

export const getPhosphateLegalWorkingCoefficients = createSelector(
  getPhosphateLegalWorkingCoefficientState,
  phosphateLegalWorkingCoefficientSelectors.selectAll,
);

export const getPhosphateLegalWorkingCoefficientsPagination = createSelector(getAppState, (state) => state?.phosphateLegalWorkingCoefficientsPagination);

export const getPhosphateLegalWorkingCoefficientsNumberOfItems = createSelector(
  getPhosphateLegalWorkingCoefficientsPagination,
  (pagination) => pagination?.itemCount,
);

export const getPhosphateLegalWorkingCoefficientsFilter = createSelector(getAppState, (state) => state?.phosphateLegalWorkingCoefficientsFilter);
